export function initScrambleText() {
	if (typeof gsap === 'undefined' || typeof gsap.utils === 'undefined' || typeof gsap.to === 'undefined') {
		console.error('GSAP or ScrambleTextPlugin is not loaded.');
		return;
	}

	// Initialize the scramble text effect
	const scrambleItems = gsap.utils.toArray('.scramble, .scramble-children a');

	scrambleItems.forEach(item => {
		const textLength = item.textContent.length;
		const originalText = item.textContent;
		const randomChars = Array.from({ length: textLength }, () => {
			const chars = 'abcdefghijklmnopqrstuvwxyz';
			return chars[Math.floor(Math.random() * chars.length)];
		}).join('');

		let tween = gsap.to(
			item,
			{
				duration: 0.5,
				scrambleText:
				{
					text: originalText,
					chars: randomChars,
					speed: 0.15,
					ease: "power1.inOut",
				},
				paused: true
			}
		);
		item.addEventListener('mouseenter', () => {
			item.style.display = 'inline-block';
			item.style.minWidth = `${item.offsetWidth}px`;
			tween.play();
		});
		item.addEventListener("mouseleave", () => {
			tween.progress(0).pause();
		});
	});

	const scrambleOnInitItems = gsap.utils.toArray('.scramble-init');
	scrambleOnInitItems.forEach(item => {
		const textLength = item.textContent.length;
		const originalText = item.textContent;
		const randomChars = Array.from({ length: textLength }, () => {
			const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
			return chars[Math.floor(Math.random() * chars.length)];
		}).join('');

		gsap.to(item, {
			duration: 5,
			scrambleText: {
				text: originalText,
				chars: randomChars,
				speed: 0.5,
				ease: "power1.inOut",
			},
			delay: 0.5
		});
	});
}

export function initScrambleHeader() {
	const scrambleHeaderElement = document.querySelector('.scramble-header');
	if (!scrambleHeaderElement) return;

	const split = new SplitText(scrambleHeaderElement, {
		type: "lines,words",
		linesClass: "line",
	});

	new SplitText(scrambleHeaderElement, {
		type: "lines",
		linesClass: "lineParent"
	});

	gsap.set(scrambleHeaderElement, { autoAlpha: 1 });

	gsap.from(split.lines, {
		duration: 0.6,
		yPercent: 100,
		opacity: 0,
		ease: "power2.out",
		stagger: {
			each: 0.1,
			onStart: function() {
				const target = this.targets()[0];
				
				gsap.to(target, {
					duration: 0.8,
					ease: "power2.out",
					scrambleText: {
						text: target.textContent,
						chars: "lowerCase",
						speed: 0.8
					}
				});
			}
		}
	});
}

export function initLinesReveal() {
	const linesRevealElements = document.querySelectorAll('.lines-reveal');
	if (!linesRevealElements) return;

	linesRevealElements.forEach(element => {
		const split = new SplitText(element, {
			type: "lines",
			linesClass: "line"
		});

		new SplitText(element, { type: "lines", linesClass: "lineParent" });

		gsap.set(element, { autoAlpha: 1 });

		gsap.from(split.lines, {
			duration: 0.6,
			yPercent: 100,
			opacity: 0,
			ease: "power2.out",
			stagger: 0.1
		});
	});
}

export function runLinesReveal( element, mode ) {
	if (!element || !mode) return;

	let split = element.splitTextInstance;
    if (!element.splitTextInstance) {
        // Your two SplitText calls were redundant. One is enough.
        // It creates parent divs for the lines automatically.
        element.splitTextInstance = new SplitText(element, {
            type: "lines",
            linesClass: "line" // The inner wrapper
        });
        split = element.splitTextInstance;

		new SplitText(element, { type: "lines", linesClass: "lineParent" });

        // Make the main element visible once it's set up
        gsap.set(element, { autoAlpha: 1 });
    }

	gsap.set(element, { autoAlpha: 1 });

	gsap.killTweensOf(split.lines);

	if ( 'reveal' === mode ) {
		gsap.set(element, { autoAlpha: 1 });
		gsap.from(split.lines, {
			duration: 0.6,
			yPercent: 100,
			opacity: 0,
			ease: "power2.out",
			stagger: 0.1
		});
	} else {
		gsap.from(split.lines, {
			duration: 0,
			yPercent: 0,
			opacity: 100,
			ease: "power2.out",
			stagger: 0.1
		});

		setTimeout(() => {
			element.style.visibility = 'hidden';
			gsap.set(element, { autoAlpha: 0 });
		},2500);
	}
}